import { useFormik } from "formik";
import Chip from "global/Chip/Chip";
import CustomPersonalizeForm from "global/CustomSwitchInput/CustomPersonalizeForm";
import { useFetchHub } from "global/hooks/useFetchOptions";
import InputTreeSelect from "global/InputSelect/inputTreeSelect";
import { paginationType } from "global/Interfaces/Interfaces";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "redux/HubData/HubData";
import {
  filterCreditSettlement,
  setFilterCreditSettlement,
} from "redux/settlement-credit";
import { GroupFilterElements } from "./CreditInitilFilter";
import { toast } from "react-toastify";

const DeliverySearchForm: FC<{}> = ({}) => {
  const userInfo = useSelector((state: any) => state.userInfo);
  const [chipData, setChipData] = useState("");
  const [selectedNodes, setSelectedNodes] = useState([
    {
      id: userInfo.currenthub?.id,
      label: userInfo.currenthub?.label,
    },
  ]);

  const { pageNumbers } = useSelector(
    (state: paginationType) => state.paginate
  );
  const { options: hubOptions } = useFetchHub();
  const statusOptions = [
    { id: 2, text: "همه" },
    { id: 0, text: "در انتظار پرداخت" },
    { id: 1, text: "پرداخت شده" },
  ];
  const [filterData, setFilterData] = useState({});
  const dispatch = useDispatch();
  const { creditFilter } = useSelector(
    (state: any) => state.creditsettlementFilter
  );
  const url = new URL(window.location.href);
  const isBack = url.searchParams.get("isBack");
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      creditValidFrom: null,
      creditValidTo: null,
      isActive: true,
      hubList: [],
      settlementStatus: { id: 2, text: "همه" },
    },
    onSubmit: async (values: any) => {
      if (
        (values.creditValidTo?.year && !values.creditValidFrom?.year) ||
        (values.creditValidFrom?.year && !values.creditValidTo?.year)
      ) {
        toast.warning("مقدار هر دو ماه را پر کنید");
        return;
      }
      dispatch(
        setFilter({
          ...values,
        })
      );
      const finalData = {
        ...values,
        creditValidTo: values.creditValidTo ?? undefined,
        creditValidFrom: values.creditValidFrom ?? undefined,
        settlementStatus:
          values.settlementStatus.id === 2
            ? undefined
            : values.settlementStatus.text,
        hubList: values.hubList.map((item) => item.label).toString(),
      };
      setFilterData(finalData);
      setChipData({
        ...finalData,
        creditValidTo: values.creditValidTo?.year
          ? values.creditValidTo?.year + "/" + values.creditValidTo?.month
          : undefined,
        creditValidFrom: values.creditValidFrom?.year
          ? values.creditValidFrom?.year + "/" + values.creditValidFrom?.month
          : undefined,
      });
    },
  });

  const { values, handleSubmit }: any = formik;

  useEffect(() => {
    if (isBack === "true") return;
    const finalData = {
      ...values,
      settlementStatus:
        values.settlementStatus?.id === 2
          ? undefined
          : values.settlementStatus.id,
      creditValidTo: values.creditValidTo
        ? { ...values.creditValidTo, day: 30 }
        : null,
      hubList:
        values.hubList.length > 0
          ? values.hubList.map((hub) => ({ id: hub.id }))
          : [{ id: userInfo?.currenthub?.id }],
    };
    dispatch(setFilterCreditSettlement({ ...finalData }));
    dispatch(
      filterCreditSettlement({
        ...finalData,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    );
    return () => {
      // dispatch(clearCreditSettlement());
    };
  }, [filterData, pageNumbers, dispatch]);

  useEffect(() => {
    if (isBack === "true") {
      dispatch(setFilterCreditSettlement({ ...creditFilter }));
      formik.setValues({
        ...values,
        creditValidFrom: creditFilter.creditValidFrom,
        creditValidTo: creditFilter.creditValidTo,

        // settlementStatus:creditFilter.settlementStatus
      });
      dispatch(
        filterCreditSettlement({
          ...creditFilter,
          pageSize: 10,
          pageNumber: pageNumbers,
        }) as any
      );
      setFilterData({ ...creditFilter });
      const url = new URL(window.location.href);
      setTimeout(() => {
        url.searchParams.set("isBack", "false");
        window.history.pushState({}, "", url);
      }, 500);
    }
  }, [isBack, creditFilter]);

  useEffect(() => {
    formik.setFieldValue("hubList", selectedNodes);
  }, [selectedNodes.length]);

  return (
    <>
      <form onSubmit={handleSubmit} className="searchForm ">
        <InputTreeSelect
          selectedNodes={selectedNodes}
          setSelectedNodes={setSelectedNodes}
          type="select"
          wrapperClassName="filterInput "
          initialValue={userInfo.currenthub?.label}
        />
       
        {GroupFilterElements.map((item: any, index: number) => {
          return (
            <>
              <CustomPersonalizeForm
                key={index}
                element={item}
                formik={formik}
                selectOptions={{
                  hubOptions,
                  statusOptions,
                }}
                // fetchInputOnchange={fetchInputOnchange}
              />
            </>
          );
        })}
        <SimpleButton searchBtn />
      </form>

      {filterData && (
        <Chip
          filterData={chipData}
          formData={formik}
          action={() => setSelectedNodes([])}
        />
      )}
    </>
  );
};

export default DeliverySearchForm;
